<template>
  <div class="wp-history-internal-comment">
    <span class="workpermit-content-slot__history-label">{{ $t('workPermit.internalCommentsHistoryLabel') }}</span>
    <pre class="workpermit-content-slot__history-pre">{{ text }}</pre>
  </div>
</template>

<script>
export default {
  name: 'WpHistoryInternalCommentBlock',
  props: {
    text: {
      default: null,
    },
  },
}
</script>
